import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container mx-auto pt-8 pb-16 px-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-gray-100 text-3xl font-semibold pt-2" }, "Absences Calendar", -1)
const _hoisted_3 = { class: "bg-white text-gray-700 p-4 mt-8 rounded-md shadow-md" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "mb-4 flex justify-between flex-col sm:flex-row" }
const _hoisted_7 = { class: "flex rounded-md mb-2 sm:mb-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-200 bg-gray-50 text-gray-500 text-sm" }, " Month ", -1)
const _hoisted_9 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_absences_calendar_table = _resolveComponent("absences-calendar-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Loading. "))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedMonth) = $event)),
                  class: "form-select appearance-none block w-full md:w-auto text-sm font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-200 rounded-r-md"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (month) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: month.key,
                      value: month
                    }, _toDisplayString(month.name), 9, _hoisted_9))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.selectedMonth]
                ])
              ])
            ]),
            (_ctx.selectedMonth)
              ? (_openBlock(), _createBlock(_component_absences_calendar_table, {
                  month: _ctx.selectedMonth,
                  key: _ctx.selectedMonth.key
                }, null, 8, ["month"]))
              : _createCommentVNode("", true)
          ]))
    ])
  ]))
}